export default __webpack_public_path__ + "static/media/home-business-corporate-img-02.d70fbbee.jpg";